{
    "name": "Acorn Squash",
    "binomial_name": "Curcurbita pepo",
    "common_names": [],
    "description": "Dark green and/or orange to yellow patterned rind with longitudinal ridges. Acorn-shaped, generally 4-7 inches long. Sweet, yellow-orange flesh inside. Belongs to the same species as summer squashes like zucchini and crookneck squash.",
    "sun_requirements": "Full Sun",
    "sowing_method": "seeds",
    "spread": 150,
    "row_spacing": 60,
    "height": 30,
    "growing_degree_days": 0,
    "companions": [
        "borage",
        "corn"
    ],
    "image": "/crops/images/acorn-squash.jpg",
    "icon": "/crops/icons/acorn-squash.avif"
}